import * as React from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Icon } from "@/components/common/icon";

import { twMerge } from "tailwind-merge";

const Checkbox = React.forwardRef(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    className={twMerge(
      "peer h-6 w-6 rounded-full border ring-offset-white focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-700 focus-visible:ring-offset-6 disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary-600 data-[state=checked]:border-primary-400 data-[state=checked]:text-white data-[state=unchecked]:border-neutral-500 data-[state=unchecked]:text-white hover:bg-primary-800 active:bg-primary-700 transition duration-150 ease-in-out",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      className={twMerge("flex items-center justify-center text-current")}
    >
      <Icon className="w-4 h-4" faIcon={{ style: "fal", name: "check" }}></Icon>
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;

export { Checkbox };
